import styled from "styled-components";
import H4 from "../../H4/H4";
const Wrapper = styled.div`
  background: ${({ theme }) => theme.black};
  border-radius: 24px;
  position: absolute;
  top: 13%;
  z-index: 999;
  text-align: center;
  left: 50%;
  transform: translate(-50%, -13%);
  font-family: ${({ theme }) => theme.fonts.sofia};
  font-weight: 300;
  font-style: normal;
  font-size: 0.8rem;
  line-height: 100%;
  padding: 0.5rem 1rem;
  width: 60% !important;
  color: ${({ theme }) => theme.white};
  > * {
    color: ${({ theme }) => theme.white};
  }
  @media (max-width: 768px) {
    margin-top: 10px;
    width: 80%;
  }
`;

function CardUtils({ children }) {
  return (
    <Wrapper>
      <H4>{children}</H4>
    </Wrapper>
  );
}

export default CardUtils;
